let testMode = false

export const isTestMode = () => testMode

export const setTestMode = (mode: boolean) => (testMode = mode)
